import { FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { dataAttrs } from 'Helpers/Testing';
import useMobileLayout from 'Hooks/useMobileLayout';
import FacetPlanProposalScenarioPreviewCard from './FacetPlanScenarioSelectionPreviewCard';


export default function FacetPlanProposalScenarioSelectionReviewSection({ reviewSectionResource }) {
  const { isPageContentLoading } = usePageContentContext();
  const isMobile = useMobileLayout();

  return (
    <FDStack
      direction={'row'}
      spacing={2}
      justifyContent="center"
      wrap={!!isMobile}
      {...dataAttrs('scenario-selection-intro-page-review-section')}
    >
      {reviewSectionResource.attr('scenarioPreviews').resources().list().map((el) => {
        return (
          <FacetPlanProposalScenarioPreviewCard
            scenarioPreviewResource={el}
            key={el.id()}
            disabled={isPageContentLoading}
          />);
      })}
    </FDStack>
  );
}

FacetPlanProposalScenarioSelectionReviewSection.defaultProps = {
};

FacetPlanProposalScenarioSelectionReviewSection.propTypes = {
  reviewSectionResource: PropTypes.object.isRequired,
};
